module.exports = __webpack_public_path__ + "static/media/CirculoPuntitosAzul.16d0daf7.svg";